module.exports = __webpack_public_path__ + "img/icon_key.cf7076e5.svg";